"use client";
import ProfileCard from "@/components/designer-grid/ProfileCard";
import type { Profile } from "@/hooks/designer-grid/types";
export function DirectoryCards({ profiles }: { profiles: Profile[] }) {
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">{profiles.map(profile => <ProfileCard key={profile.id} profile={profile} />)}</div>;
}
